import type {
  PlaceholderId,
  SlideElement,
  SlideTemplate,
  SlideTemplateInfo,
  TextElement,
} from '@/shared/types/slide';

// ---------------------------------------------------------------------------
// Default elements per template — bare placeholder-bound text elements (§8.3).
// Geometry/style come from the theme's layout at render time, so these carry only
// `placeholderId` + empty content; empty content renders a "Click to add …" hint.
// ---------------------------------------------------------------------------

function placeholderText(placeholderId: PlaceholderId): TextElement {
  return { id: crypto.randomUUID(), type: 'text', placeholderId, content: { text: '' } };
}

export function getDefaultElements(template: SlideTemplate): SlideElement[] {
  switch (template) {
    case 'TITLE':
      return [placeholderText('TITLE'), placeholderText('SUBTITLE')];

    case 'TITLE_AND_BODY':
      return [placeholderText('TITLE'), placeholderText('BODY')];

    case 'TITLE_AND_TWO_COLUMNS':
      return [
        placeholderText('TITLE'),
        placeholderText('LEFT_BODY'),
        placeholderText('RIGHT_BODY'),
      ];

    case 'BLANK':
      return [];
  }
}

// ---------------------------------------------------------------------------
// Template metadata (for layout picker UI)
// ---------------------------------------------------------------------------

export const SLIDE_TEMPLATES: SlideTemplateInfo[] = [
  {
    template: 'TITLE',
    name: 'Title Slide',
    description: 'A slide with a title and subtitle',
  },
  {
    template: 'TITLE_AND_BODY',
    name: 'Title and Body',
    description: 'A slide with a title and body content',
  },
  {
    template: 'TITLE_AND_TWO_COLUMNS',
    name: 'Two Columns',
    description: 'A slide with a title and two columns',
  },
  {
    template: 'BLANK',
    name: 'Blank',
    description: 'An empty slide',
  },
];
